module.exports = __webpack_public_path__ + "img/023.77a89167.jpg";